import { Component, inject, input, output } from '@angular/core';
import { Facet, FacetAlias, FacetAliasNamesPlural } from 'app/my-history/facet/facet';
import { TabsFilterComponent } from 'app/shared/tabs-filter/tabs-filter.component';
import { ButtonColor, ButtonComponent } from 'app/shared/button/button.component';
import { IconComponent } from 'app/shared/icon/icon.component';
import { provideNgIconLoader, withCaching } from '@ng-icons/core';
import { FacetIcons } from 'app/my-history/facet/facet-icons.const';
import { HttpClient } from "@angular/common/http";

@Component({
  selector: 'app-facet-pills',
  standalone: true,
  imports: [TabsFilterComponent, ButtonComponent, IconComponent],
  templateUrl: './facet-pills.component.html',
  styleUrls: ['./facet-pills.component.scss'],
  providers: [
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
  ],
  host: {
    class: 'block',
  },
})
export class FacetPillsComponent {
  hideDescription = input(false)
  facets = input.required<Facet[] | undefined>();
  selectedFacet = input<FacetAlias | null | undefined>(null);
  facetType = input<'all' | 'user' | 'userNoChapter'>('user');
  withDescription = input(false);
  isUnclick = input(false);
  isDetaied = input(false);
  isPreviewMode = input(false);
  selected = output<Facet | null>();

  onSelected(facet: Facet) {
    if (this.isUnclick() && this.selectedFacet() === facet.alias) {
      this.selected.emit(null);
    } else {
      this.selected.emit(facet);
    }
  }

  getFacetIcon(facet: Facet): string {
    return FacetIcons[facet.alias];
  }

  getFacetName(facet: Facet): string {
    return facet.alias === FacetAlias.chapter ? '' : facet.name ? facet.name : 'Unnamed';
  }

  getFacetNameByAlias(alias: FacetAlias | null | undefined): string | null {
    if (!alias) return null;
    return FacetAliasNamesPlural[alias];
  }

  getFacetColor(facet: Facet): ButtonColor {
    return facet.alias === this.selectedFacet() ? 'blue' : 'outlineBlue';
  }

  getButtonClass(facet: Facet): string {
    if (this.facetType() === 'user') {
      return facet.alias === this.selectedFacet() ? 'selected-button-user': 'button-user';
    }

    return ''
  }
}
